import { lerp } from './assets/_utils'

class BgParallax {
  constructor(target, option) {
    this.elmParent = target
    this.elmFront = target.querySelector('.bgParallax__front')
    this.elmBack = target.querySelector('.bgParallax__back')

    this.state = {
      perCurrent: -1,
      perTarget: -1,
      multiplier: 0.1,
      powerFront: 0.2,
      powerBack: 0.05,
    }

    Object.assign(this.state, option)

    document.addEventListener('scroll', this.onScroll)

    this.onScroll()
    this.update()
  }

  onScroll = () => {
    const { elmParent, state } = this

    const scrollCenter = document.documentElement.scrollTop + document.documentElement.clientHeight * 0.5
    const rect = elmParent.getBoundingClientRect()
    const areaCenter = rect.top + rect.height * 0.5 + document.documentElement.scrollTop
    // state.perTarget = ((scrollCenter - areaCenter) / rect.height).clamp(-1, 1)
    state.perTarget = (scrollCenter - areaCenter) / document.documentElement.clientHeight
  }

  update = () => {
    const { elmFront, elmBack, state } = this
    const { perCurrent, perTarget, powerFront, powerBack, multiplier } = state

    state.perCurrent = lerp(perCurrent, perTarget, multiplier)

    const pf = document.documentElement.clientHeight * state.perCurrent * powerFront
    const pb = document.documentElement.clientHeight * state.perCurrent * powerBack

    elmFront.style.transform = `translate3d(0, calc(-50% + ${-pf}px), 0)`
    elmBack.style.transform = `translate3d(0, calc(-50% + ${-pb}px), 0)`

    requestAnimationFrame(this.update)
  }
}

document.querySelectorAll('.bgParallax').forEach((elm) => {
  new BgParallax(elm)
})
